import { createContext } from "react";
import { UserGeneralProfile } from "@jugl-web/rest-api";
import {
  AIAgent,
  AIAssistantMessage,
  AIUserPerformanceDialogState,
} from "../types";

export const AIAssistantContext = createContext<{
  messages: AIAssistantMessage[];
  isAILimitReached: boolean;
  isDataCopied: boolean;
  isAIAssistantDialogOpen: boolean;
  entityId: string;
  isChannelError: boolean;
  isError: boolean;
  agent?: AIAgent;
  user?: UserGeneralProfile;
  resendMessage: () => void;
  reconnectChannel: () => void;
  handleOpenAIAssistantDialog: (isOpen: boolean, boardId?: string) => void;
  changeAgent: (agent: AIAgent) => void;
  copyData: (data: string) => void;
  openUserPerformanceDialog: (state: AIUserPerformanceDialogState) => void;
  sendMessage: (prompt: string) => void;
} | null>(null);
